import { fileShareFileMenuClick } from '@wix/bi-logger-wixlabs-ugc/v2';

export const biFileShareWidgetFileMenuClick = (props: any) => {
  const {
    instance_id,
    app_id,
    logger,
    visitor_id,
    comp_id,
    owner,
    file_id,
    file_name,
    file_owner,
    file_size,
    file_type,
    button_description,
    favorites_count,
    is_folder,
    num_of_files_selected,
    views_count,
  } = props;
  logger?.report(
    fileShareFileMenuClick({
      instance_id,
      app_id,
      visitor_id,
      comp_id,
      owner,
      file_id,
      file_name,
      file_owner,
      file_size,
      file_type,
      button_description,
      favorites_count,
      is_folder,
      num_of_files_selected,
      views_count,
    }),
  );
};
